<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="businessCategoryAudits && businessCategoryAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="businessCategoryAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Payment Type audits </ng-template>
</ng-template>
